import React from 'react';
import SessionsList from './list';
import SessionDetails from './details';
import { Route, Routes } from 'react-router-dom';
import { useIsAfterSalesAdmin, useIsFactoryAdmin } from '../../auth';

export default function SessionsView() {
    const isFactoryAdmin = useIsFactoryAdmin();
    const isAfterSalesAdmin = useIsAfterSalesAdmin();
    if (!isFactoryAdmin && !isAfterSalesAdmin) return null;

    return (
        <Routes>
            <Route path='/' exact element={<SessionsList />} />
            <Route path='/:id/details' element={<SessionDetails />} />
        </Routes>
    );
}
